module.exports = __webpack_public_path__ + "static/media/mask_v2_ac.81ce0408.png";